import de from './de.json';

const modules = { de };

module.exports = modules;
